import React, {useState} from 'react';

import {
    Box,
    Button,
    HStack,
} from "@chakra-ui/react";
import { SecureIframe } from './components/SecureIframe';

const Reserve: React.FC = () => {
    const baseUrl = process.env.REACT_APP_RESERVE_BASE_URL;
    if (!baseUrl) {
        throw new Error("REACT_APP_RESERVE_BASE_URL is not defined");
    }
    const [src, setSrc] = useState(`${baseUrl}/ftt/shop_manager/time_table`);

    const menu = [
        { label: "タイムテーブル", url: `${baseUrl}/ftt/shop_manager/time_table` },
        { label: "予約受付履歴", url: `${baseUrl}/shop_manager/reservation/history` },
        { label: "予約一覧", url: `${baseUrl}/ftt/shop_manager/reserves` },
        { label: "予約の自動取込履歴", url: `${baseUrl}/shop_manager/ses_import_histories` },
        // { label: "予約ブロック", url: `${baseUrl}/shop_manager/reservation_block` },

    ];

    return (
        <Box
            transform="scale(0.8)"
            transformOrigin="top left"
            width="125%"   // 1 / 0.8 = 1.25 → 見切れ防止
            height="125%"
        >
                <HStack spacing={4} mb={4} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
                    {menu.map((item) => (
                        <Button
                            key={item.label}
                            onClick={() => setSrc(item.url)}
                            colorScheme="blue"
                            variant="outline"
                        >
                            {item.label}
                        </Button>
                    ))}
                </HStack>
                <SecureIframe src={src} />
            </Box>
    );
};

export default Reserve;